import { ApiConstants } from "./apiConstants";
import { DomainProps } from "./domainProps";


export class DomainConstants extends ApiConstants {
  public apiDomain: DomainProps;

  constructor(timeout: number) {
    super(timeout);

    this.apiDomain = {

      exemplo: {
        getExemplo: `${this.api.baseUrl}/exemplo/getExemplo`
      },
      home: {
        get: `${this.api.baseUrl}/home/get`
      },
      campanhaPedidoResgate: {
        GetSolicitadosByUsuario: `${this.api.baseUrl}/CampanhaPedidoResgate/GetSolicitadosByUsuario`,
        GetSolicitadosByCampanha: `${this.api.baseUrl}/CampanhaPedidoResgate/GetSolicitadosByCampanha`,
        GetSolicitadosAprovadosByCampanha: `${this.api.baseUrl}/CampanhaPedidoResgate/GetAprovadosByCampanha`
      },
      usuario: {
        getManyByEmpresa: `${this.api.baseUrl}/usuario/getManyByEmpresa`,
      },
      filial: {
        getManyFilialEmpresa: `${this.api.baseUrl}/filial/getManyFilialEmpresa`
      },
      filialUsuario: {
        getFilialEmpresaByEmpresaId: `${this.api.baseUrl}/FilialUsuario/GetFilialEmpresaByEmpresaId`
      },
      authentication: {
        loginByToken: `${this.api.baseUrl}/authentication/byToken`,
        logOut: `${this.api.baseUrl}/authentication/logOut`,
        testSSE: `${this.api.baseUrl}/authentication/TestSSE`
      },
      sistema: {
        getSistema: `${this.api.baseUrl}/sistema/getSistema`,

        getSistemas: `${this.api.baseUrl}/sistema/getSistemas`
      },
      parceiro: {
        getByUrl: `${this.api.baseUrl}/parceiro/GetByUrl`
      },
      perfil: {
        getAtivos: `${this.api.baseUrl}/perfil/getAtivos`,
      },
      usuarioSistemaPerfil: {
        getUsuarioSistemaPerfil: `${this.api.baseUrl}/usuarioSistemaPerfil/getUsuarioSistemaPerfil`,
      },
      IBGE: {
        estados: `${this.api.ibgeUrl}/localidades/estados`,
      },
      carteira: {
        // getUserInfo: (carteiraId: number) => `${this.api.campanhaUrl}/carteira/${carteiraId}/get-info`,
        //  'https://localhost:7148/CampanhaUsuario/GetCarteiraInfo?carteiraId=8&usuarioId=1123123'
        getUserInfo: (carteiraId: number, usuarioId: number) => `${this.api.campanhaUrl}/CampanhaUsuario/GetCarteiraInfo?carteiraId=${carteiraId}&usuarioId=${usuarioId}`,
        // getUserInfoCampanha: (carteiraId: number) => `${this.api.campanhaUrl}/carteira/${carteiraId}/get-info/por-campanha`,
        //https://localhost:7148/CampanhaUsuario/GetCarteiraInfoPorCampanha?carteiraId=8&campanhaId=1172&usuarioId=79117
        getUserInfoCampanha: (carteiraId: number, usuarioId: number, campanhaId: number) => `${this.api.campanhaUrl}/CampanhaUsuario/GetCarteiraInfoPorCampanha?carteiraId=${carteiraId}&campanhaId=${campanhaId}&usuarioId=${usuarioId}`,
        //https://localhost:7148/CampanhaUsuario/GetCarteiraUsuario?usuarioId=79117&empresaId=221
        getCarteiraUsuario: (usuarioId: number, empresaId: number) => `${this.api.campanhaUrl}/CampanhaUsuario/GetCarteiraUsuario?usuarioId=${usuarioId}&empresaId=${empresaId}`,
      }

    } as DomainProps
  }
}

export default new DomainConstants(1000);
